<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

<div [ngClass]="currentTheme">
    <div class="page" [ngClass]="{'dtp-buffer':headerData.show_dtp}">
      <router-outlet></router-outlet>
    </div>
</div>
